module.exports = __webpack_public_path__ + "images/backgrounds/dew/large.d27257a2404aa75f328a.jpg";